<template>
    <div>
        <date-picker 
            v-model="internalValue"
            :input-attr="{ name: name }" 
            value-type="YYYY-MM-DD" 
            format="DD-MM-YYYY"
            :disabled-date="disabledDate"> 
        </date-picker>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/da';

export default {
    components: { DatePicker },
    props: ['name', 'value'],
    methods: {
        disabledDate(date) {
            return date < new Date(1900, 0, 1);
        }
    },
    data() {
        return {
            internalValue: this.value
        };
    },
    mounted() {
        console.log(this.value);
    }
};
</script>

<style>
.padding-date-picker {
    .mx-input {
        padding: 0 10px !important;
    }
}
.mx-datepicker {
    width: 100%;
    display: block;

    .mx-input {
        box-shadow: none;
        border: none;
        display: block;
        padding: 0;
        background: none;
        color: #000;
        font-size: 16px;
        height: 26px;
    }
}
</style>